import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import {
  getRequiredPortalUserFromLocation,
  verifyAndPreparePortalSession,
  PORTAL_ACCOUNT_MISMATCH_MESSAGE,
} from "../constants/auth";

const LOGIN_PATH = "/customer-portal/login";

const CustomerPortalGuard = ({ children }) => {
  const location = useLocation();
  const required = getRequiredPortalUserFromLocation(location);
  const { session, mismatch } = verifyAndPreparePortalSession(required);

  if (!session) {
    return (
      <Navigate
        to={`${LOGIN_PATH}${location.search || ""}`}
        replace
        state={{
          from: location,
          accountMismatch: mismatch,
          message: mismatch ? PORTAL_ACCOUNT_MISMATCH_MESSAGE : undefined,
          requiredUser: required,
        }}
      />
    );
  }

  return children;
};

export default CustomerPortalGuard;
